import React from 'react';
import styles from '@dazn/lp-web/src/components/Footer/footer.module.css';
import {useFeLabelsState} from '@dazn/lp-web/src/contexts/FeLabelsContext';

const Trademark: React.FC = () => {
    const {labels} = useFeLabelsState();
    const trademarkKey = labels.get({
        stringKey: 'footer_trademark'
    });
    return (
        <span className={styles.trademark}>
            <p>{trademarkKey}</p>
        </span>
    );
};

export default Trademark;
